<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="969px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="名称" prop="Name">
              <el-input
                v-model="formData.Name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="地址" prop="Location">
              <el-input
                v-model="formData.Location"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="封面" prop="Picture">
              <el-upload
                class="avatar-uploader"
                :data="{ Type: 5 }"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="formData.Picture"
                  :src="formData.Picture"
                  class="avatar"
                />
                <i v-else class="center el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="排序序号">
              <el-input
                v-model="formData.bSort"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="户型简介" prop="Description">
              <div style="border: 1px solid #ccc; box-sizing: border-box">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                />
                <Editor
                  :style="`height: 300px; overflow-y: hidden;`"
                  :defaultConfig="editorConfig"
                  v-model="formData.Description"
                  @onCreated="onCreated"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="申请条件" prop="Requirements">
              <div style="border: 1px solid #ccc; box-sizing: border-box">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor1"
                  :defaultConfig="toolbarConfig1"
                />
                <Editor
                  :style="`height: 300px; overflow-y: hidden;`"
                  :defaultConfig="editorConfig1"
                  v-model="formData.Requirements"
                  @onCreated="onCreated1"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetApartmentById,
  PutApartment,
  AddApartment,
} from "@/api/talentApartmet/index";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { uploadFile } from "@/api/upload/upload";
import * as Api from "../../api/api";

export default {
  components: { Editor, Toolbar },
  data() {
    return {
      uploadUrl: Api.uploadUrl,
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Location: [{ required: true, message: "请输入地址", trigger: "blur" }],
        Picture: [{ required: true, message: "请上传封面", trigger: "change" }],
        Description: [
          { required: true, message: "请输入户型简介", trigger: "change" },
        ],
        Requirements: [
          { required: true, message: "请输入申请条件", trigger: "change" },
        ],
      },
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let alt = file.name;
                let href = ``;
                insertFn(url, alt, href);
              } else {
                this.$message.error("图片上传失败");
              }
            },
          },
          uploadVideo: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let poster = "";

                insertFn(url, poster);
              } else {
                this.$message.error("视频上传失败");
              }
            },
          },
        },
      },
      editor1: null,
      toolbarConfig1: {},
      editorConfig1: {
        placeholder: "请输入内容...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let alt = file.name;
                let href = ``;
                insertFn(url, alt, href);
              } else {
                this.$message.error("图片上传失败");
              }
            },
          },
          uploadVideo: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let poster = "";

                insertFn(url, poster);
              } else {
                this.$message.error("视频上传失败");
              }
            },
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    openDialog(e, key) {
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
      };
      this.title = dic[key];
      key == "edit" && this.HttpQueryBlogDetail({ id: e.Id });
      key == "add" &&
        (this.formData = {
          Name: "",
          Location: "",
          ImageUrls: [],
          Picture: "",
          Requirements: "",
          Description: "",
          bSort: 0,
        });
      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
      console.log("Url", this.formData);
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      const isLt4M = file.size / 1024 / 1024 < 10;
      console.log(file.type);
      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
      }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return isImage && isLt4M;
      return isImage;
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = { ...this.formData, ImageUrls: [this.formData.Picture] };
      if (param.Content == `<p><br></p>`) {
        this.$message.error("请输入内容");
        return;
      }
      this.key == "add" && this.HttpAddBlogDetail(param);
      this.key == "edit" && this.HttpUpdateBlogDetail(param);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    onCreated1(editor) {
      this.editor1 = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpQueryBlogDetail(param) {
      this.isLoading = true;
      const response = await GetApartmentById(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        this.formData = { ...raw, Picture: raw.ImageUrls[0] };
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await PutApartment(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await AddApartment(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
